import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"columns is-centered\"><div class=\"column\" style=\"margin-top:15%;margin-bottom:20%;\"><h3 class=\"is-size-3 has-text-centered\">Thanks for your order!</h3><div class=\"field has-text-centered mt-6\"><p> We appreciate your business! <br> If you have any questions, please email <a href=\"mailto:info@aureis.eu\">info@aureis.eu</a>. </p></div></div></div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, _hoisted_2))
}